import React, {Component} from 'react'
import {Pagination, message} from 'antd'
import BasketsTable from './table/BasketsTable'
import FilterOptions from '../../home/components/filters/FilterOptions'
import {BASKET_LOCATION, BASKET_STATUS, BASKET_TOTAL_ITEMS, listPartner, listBasketType} from '../helper/basketFilters'
import SearchField from '../../home/components/filters/SearchField'
import {getListBaskets, exportListBaskets, exportListBasketsUncompleted} from "../../../services/api/mergerApi"
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import moment from 'moment'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import ModalReleaseBaskets from "./ModalReleaseBaskets"
import {parseJwt} from "../../../helpers/parseToken"
import {getLocalData} from "../../../services/StorageServices"
import SearchField2 from '../../home/components/filters/SearchField2'
import SelectFilterOptions from '../../shared/SelectFilterOptions'

class BasketsPage extends Component {
    state = {
        baskets: [],
        total: 0,
        limit: 50,
        page: 1,
        pages: 1,
        loading: false,
        error: '',
        filters: {
            location: 'all',
            overtimes: []
        },
    }

    componentDidMount() {
        const role = parseJwt(getLocalData('accessToken')).roles
        this.setState({
            isAdmin: role.some(item=> item.name==="Super Admin")
        })

        this._fetchBaskets()
    }

    _fetchBaskets = async () => {
        this.setState({
            loading: true,
        })

        try {
            const {limit, page, filters} = this.state
            const payload = {
                limit,
                page: page,
                ...filters,
            }

            const {data: response} = await getListBaskets(payload)

            const {data, success, error} = response

            if (!success) {
                throw new Error(error)
            }

            const {baskets, total, pages} = data

            this.setState({
                baskets,
                total,
                pages,
                loading: false,
                error: '',
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current,
        }, this._fetchBaskets)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1,
        }, this._fetchBaskets)
    }

    _handleChangeStatus = (field, value) => {
        this.setState(({filters}) => {
            return {
                filters: {
                    ...filters,
                    [field]: value,
                },
                page: 1,
            }
        }, this._fetchBaskets)
    }
    _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, this.state.filters)

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }else {
            value.from = moment(value.from,'DD/MM/YYYY').format('YYYY-MM-DD')
            value.to = moment(value.to,'DD/MM/YYYY').format('YYYY-MM-DD')
            cloneFilter[field] = value
        }
        this.setState({
            filters: {
                ...cloneFilter,
            },
            page: 1
        }, this._fetchBaskets)
    }

    _exportBaskets = async() => {
        this.setState({
            loading: true,
        })

        try {
            const {filters} = this.state
            const payload = {
                ...filters,
            }

            const {data} = await exportListBaskets(payload)
            if (data) {
                message.success('Export baskets success!')
                downloadFileFromData(data, {filename: `baskets-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`})
            }

            this.setState({
                loading: false,
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
            message.error(e.message)
        }
    }

    showModalReleaseBaskets = (e)=>{
        e && e.preventDefault()
        this.setState({
            showModalReleaseBaskets:
                !this.state.showModalReleaseBaskets
        })
    }

    getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                if(i === -1) {
                    Options.push({name: -1.5,value: -1.5,})
                }
                Options.push(Option)
            }
        }
        return Options
    }

    _exportBasketsUncompleted = async() => {
        this.setState({
            loading: true,
        })

        try {
            const {filters} = this.state
            const payload = {
                ...filters,
            }

            const {data} = await exportListBasketsUncompleted(payload)
            if (data) {
                message.success('Export baskets uncompleted success!')
                downloadFileFromData(data, {filename: `baskets-uncompleted-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`})
            }

            this.setState({
                loading: false,
            })

        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
            message.error(e.message)
        }
    }

    render() {
        const {baskets, error, page, total, limit, loading, showModalReleaseBaskets, isAdmin, filters} = this.state

        return (
            <div className='BasketsPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className='mt-3'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h3>Baskets</h3>
                                <div className="listBtn">
                                    {
                                        isAdmin &&
                                        <a className="ant-btn mr-3 ant-btn-danger btnReleaseBaskets" href=""
                                           onClick={this.showModalReleaseBaskets}>Xóa giỏ</a>
                                    }
                                    <a className="ant-btn mr-3 ant-btn-secondary" href="/statistics-add-basket">Thống kê thêm giỏ</a>
                                    <a className="ant-btn ant-btn-secondary mr-3" href="/statistics-delete-basket">Thống kê xóa giỏ</a>
                                    <a className="ant-btn ant-btn-secondary mr-3" href="/statistics-uncomplete-basket">Thống kê giỏ chưa hoàn thành</a>
                                    <button className="ant-btn ant-btn-primary mr-3" onClick={this._exportBaskets}>Export</button>
                                    <button className="ant-btn ant-btn-primary" onClick={this._exportBasketsUncompleted}>Export Uncompleted</button>
                                </div>
                            </div>
                            <div className='jumbotron p-3 mb-3'>
                                <div className='row align-items-end'>
                                    <div className='col-12 col-xl-auto mb-1'>
                                        <FilterOptions onChangeOption={this._handleChangeStatus}
                                                       defaultOption='all' field='location'
                                                       options={BASKET_LOCATION} heading='Địa chỉ:'/>
                                    </div>

                                    <div className='col-12 col-xl-auto mb-1'>
                                        <FilterOptions onChangeOption={this._handleChangeStatus} defaultOption='all'
                                                       field='status' options={BASKET_STATUS}
                                                       heading='Trạng thái giỏ:'/>
                                    </div>

                                    <div className='col-12 col-xl-auto mb-1'>
                                        <label className='d-block mb-1 font-weight-bold'>Mã đơn:</label>
                                        <SearchField field='order_number' onChangeInput={this._handleChangeStatus}
                                                     placeholder='Tìm theo mã đơn...'/>
                                    </div>

                                    <div className='col-12 col-xl-auto mb-1'>
                                        <label className='d-block mb-1 font-weight-bold'>Mã giỏ:</label>
                                        <SearchField field='basket_number' onChangeInput={this._handleChangeStatus}
                                                     placeholder='Tìm theo mã giỏ...'/>
                                    </div>

                                    <div className='col-12 col-xl-auto mb-1'>
                                        <FilterOptions onChangeOption={this._handleChangeStatus} defaultOption=""
                                                       field='total_items' options={BASKET_TOTAL_ITEMS} layout='select'
                                                       heading='Loại đơn:'/>
                                    </div>
                                    <div className='col-12 col-xl-auto mb-1'>
                                        <FilterOptions onChangeOption={this._handleChangeStatus} defaultOption=""
                                                       field='partner' options={listPartner} layout='select'
                                                       heading='Partner:'/>
                                    </div>
                                    <div className='col-12 col-xl-auto mb-1'>
                                        <label className="font-weight-bold d-block mb-1">Ngày hoàn thành:</label>
                                        <FilterDateRangeV2
                                            onDatesChange={this._handleChangeDate}
                                            field='completed_at'
                                            disabled={loading}
                                        />
                                    </div>
                                    <div className='col-12 col-xl-auto mb-1'>
                                        <label className='d-block mb-1 font-weight-bold mt-2'>Vị trí giỏ:</label>
                                        <SearchField2 value={filters.position ? filters.position : ''} field='position' onChangeInput={this._handleChangeStatus}
                                                     placeholder='Tìm theo vị trí giỏ...'/>
                                    </div>

                                    <div className='col-12 col-xl-2 mb-1'>
                                        {/* <label className="font-weight-bold d-block mb-1">Ngày hoàn thành:</label>
                                        <FilterDateRangeV2
                                            onDatesChange={this._handleChangeDate}
                                            field='completed_at'
                                            disabled={loading}
                                        /> */}

                                        <SelectFilterOptions
                                            defaultValue={filters.overtimes || []}
                                            listOptions={this.getOptionOverTime(-6,6)}
                                            style={{width: '100%'}}
                                            field="overtimes" label="Thời gian item quá hạn"
                                            handleChange={this._handleChangeStatus}
                                            mode='multiple'
                                            showArrow
                                            allowClear
                                            placeholder='Chọn thời gian item quá hạn'
                                        />
                                    </div>
                                    <div className='col-12 col-xl-auto mb-1'>
                                        <FilterOptions onChangeOption={this._handleChangeStatus} defaultOption=""
                                                       field='basket_type' options={listBasketType} layout='select'
                                                       heading='Loại giỏ:'/>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                                <div>
                                    {error && <div className='text-danger'>{error}</div>}
                                </div>
                                <Pagination current={page} total={total} pageSize={limit}
                                            showTotal={(sum, range) => sum > 0 &&
                                                <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                                </div>}
                                            onChange={this._handlePageChange}
                                            className='text-right' showSizeChanger
                                            pageSizeOptions={['10', '20', '50', '100']}
                                            onShowSizeChange={this._handleShowSizeChange}/>
                            </div>

                            <BasketsTable baskets={baskets} loading={loading} onChangeFilterPosition={this._handleChangeStatus}/>

                            <Pagination current={page} total={total} pageSize={limit}
                                        onChange={this._handlePageChange}
                                        showQuickJumper
                                        className='text-right' showSizeChanger
                                        pageSizeOptions={['10', '20', '50', '100']}
                                        onShowSizeChange={this._handleShowSizeChange}/>
                        </div>
                    </div>
                </div>
                {
                    isAdmin && showModalReleaseBaskets && <ModalReleaseBaskets
                        showModalReleaseBaskets={showModalReleaseBaskets}
                        onClose={this.showModalReleaseBaskets}
                        onCancel={this.showModalReleaseBaskets} />
                }
            </div>
        )
    }
}

export default BasketsPage
